import { getGlobalDispatch } from "../State/Context";
import { ActionType } from "../State/State";
import { Hexagen, Player } from "../types";
import { askAPI, RequestMethod } from "./api";

export const requestHexagenInfo = async (x: number, y: number) => {
  const extra = await askAPI<{
    hasUpvote: boolean;
    creator: Player | null;
    owner: Player | null;
  }>("/api/hexagen/extra", RequestMethod.GET, {
    x,
    y,
  });

  if (extra) {
    getGlobalDispatch()({
      type: ActionType.ADD_SELECTED_HEX_EXTRA,
      extra,
    });
  } else {
    // Hex does not exist; /info would return the same error and show "Hexagen not exist" again
    return false;
  }

  const info = await askAPI<Hexagen>("/api/hexagen/info", RequestMethod.GET, {
    x,
    y,
  });

  if (info) {
    getGlobalDispatch()({
      type: ActionType.ADD_SELECTED_HEX_INFO,
      hexInfo: info,
    });
    if (info.videoStatus === "READY") {
      getGlobalDispatch()({ type: ActionType.ADD_HEX_HAS_VIDEO, x: info.x, y: info.y });
    }
    return true;
  }

  return false;
};

export const startVideoGeneration = async (x: number, y: number) => {
  const result = await askAPI<{ ok: boolean; status?: string }>(
    "/api/hexagen/video/generate",
    RequestMethod.POST,
    { x, y }
  );

  if (result && result.ok) {
    await requestHexagenInfo(x, y);
    return true;
  }

  return false;
};

export const fetchVideosInBBox = async (
  x1: number,
  y1: number,
  x2: number,
  y2: number
) => {
  const list = await askAPI<Array<{ x: number; y: number }>>(
    "/api/hexagen/videos",
    RequestMethod.GET,
    { x1, y1, x2, y2 }
  );
  return Array.isArray(list) ? list : [];
};
